import React from "react";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { SDeleteAsset } from "../../../apis/app.service";
import AppButton from "../../sharedcomponents/Buttons/AppButton/AppButton";
import { useAssetsPage } from "../../../store/AssetsProvider";

export default function ConfirmAssetDelete() {
  const { asset } = useAssetsPage();
  const { data } = asset;
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: SDeleteAsset,
    onSuccess: ({ message }) => {
      queryClient.invalidateQueries({ queryKey: ["assets"] });
      toast.success(message, { duration: 3000, position: "top-right" });
    },
    onError: (error: Error) =>
      toast.error(error.message, { duration: 3000, position: "top-right" }),
  });

  return (
    <div className="modal fade" id="kt_modal_confirm_asset_delete" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered mw-600px">
        <div className="modal-content">
          <div className="modal-header">
            <h2 className="asset-modal-title">Confirm Action</h2>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            Are you sure you want to delete asset{" "}
            <strong>{data.assetNo}</strong>
            {data.description ? ` (${data.description})` : ""}? This cannot be
            undone.
          </div>
          <div className="modal-footer">
            <AppButton
              btnType="danger"
              onClick={() => data.id && mutation.mutate(data.id)}
              data-bs-dismiss="modal"
            >
              {!mutation.isPending && (
                <span className="indicator-label">Delete</span>
              )}
              {mutation.isPending && (
                <span className="indicator-progress" style={{ display: "block" }}>
                  Please wait...
                  <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                </span>
              )}
            </AppButton>
          </div>
        </div>
      </div>
    </div>
  );
}
